import React, { createContext, useState, useContext } from 'react';

const TranslationContext = createContext();

const translations = {
    en: {
        hello: 'Hello',
        logout: 'Log Out',
        manifoldManager: 'Manifold Manager',
    },
    es: {
        hello: 'Hola',
        logout: 'Cerrar sesión',
        manifoldManager: 'Gestor de Colectores',
    },
};

export const TranslationProvider = ({ children }) => {
    const [language, setLanguage] = useState('en');

    const t = (key) => translations[language][key] || key;

    return (
        <TranslationContext.Provider value={{ t, setLanguage }}>
            {children}
        </TranslationContext.Provider>
    );
};

export const useTranslation = () => useContext(TranslationContext);
